import { Classes } from '@blueprintjs/core';
import { ace_hooks } from '@axo/shared/data-access/hooks';

interface Props {
  id: string;
}

export function BucketName({ id }: Props) {
  const bucket = ace_hooks.useBucket(id);

  if (bucket.isLoading) {
    return <span className={Classes.SKELETON}>%bucket name%</span>;
  }

  return <>{bucket.data?.Name ?? bucket.data?.ID ?? id}</>;
}
